export default __webpack_public_path__ + "static/media/weight-per-minute-per-operator-icon.057b0944.png";